var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "scrollContainer",
    staticClass: "product-details",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('h4', {
    ref: "mainHeader",
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goTo('products');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('products')))]), _vm._v(" " + _vm._s(`> ${_vm.selectedProduct.name}`) + " ")]), _c('div', {
    staticClass: "product-details-column"
  }, [_c('div', {
    ref: "navigation",
    staticClass: "product-details-navigation",
    class: {
      'sticky': _vm.isSticky
    }
  }, [_c('router-view', {
    attrs: {
      "name": "navigation"
    }
  })], 1), _vm.loaded ? _c('div', {
    ref: "productContent",
    staticClass: "product-content"
  }, [_c('router-multi-view', {
    attrs: {
      "view-name": "tab"
    }
  })], 1) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }